// src/components/UserMenu.js
import React from "react";
import {
  Menu,
  MenuItem,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
} from "@mui/material";
import { Warning } from "@mui/icons-material";

const UserMenu = ({
  anchorEl,
  handleClose,
  isAdmin,
  onAdminPanel,
  handleSignOut,
  setShowMyOrders,
  setShowPackageStore,
  setCartDrawerOpen,
  setShowProfileSettings,
  getCartItemCount,
  setDeleteDialogOpen,
  deleteDialogOpen,
  handleDeleteAccount,
  loading,
  primaryBlue,
  glassStyles,
  setShowWallet,
}) => {
  return (
    <>
      {/* Enhanced User Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            ...glassStyles,
            bgcolor: "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(20px)",
            mt: 1,
            minWidth: 200,
          },
        }}
      >
        {isAdmin && (
          <MenuItem
            onClick={() => {
              onAdminPanel();
              handleClose();
            }}
            sx={{
              fontWeight: 600,
              color: primaryBlue[700],
              "&:hover": {
                bgcolor: "rgba(0, 114, 206, 0.1)",
              },
            }}
          >
            Admin Panel
          </MenuItem>
        )}

        <MenuItem
          onClick={() => {
            setShowMyOrders(true);
            handleClose();
          }}
          sx={{
            fontWeight: 500,
            color: primaryBlue[700],
            "&:hover": {
              bgcolor: "rgba(0, 114, 206, 0.1)",
            },
          }}
        >
          My Orders
        </MenuItem>

        <MenuItem
          onClick={() => {
            setShowPackageStore(true);
            handleClose();
          }}
          sx={{
            fontWeight: 500,
            color: primaryBlue[700],
            "&:hover": {
              bgcolor: "rgba(0, 114, 206, 0.1)",
            },
          }}
        >
          Subscription
        </MenuItem>

        <MenuItem
          onClick={() => {
            setCartDrawerOpen(true);
            handleClose();
          }}
          sx={{
            fontWeight: 500,
            color: primaryBlue[700],
            "&:hover": {
              bgcolor: "rgba(0, 114, 206, 0.1)",
            },
          }}
        >
          Shopping Cart ({getCartItemCount()})
        </MenuItem>

        <MenuItem
          onClick={() => {
            setShowProfileSettings(true);
            handleClose();
          }}
          sx={{
            fontWeight: 500,
            color: primaryBlue[700],
            "&:hover": {
              bgcolor: "rgba(0, 114, 206, 0.1)",
            },
          }}
        >
          Profile Settings
        </MenuItem>

        <MenuItem
          onClick={() => {
            setShowWallet(true);
            handleClose();
          }}
          sx={{
            fontWeight: 500,
            color: primaryBlue[700],
            "&:hover": {
              bgcolor: "rgba(0, 114, 206, 0.1)",
            },
          }}
        >
          Wallet
        </MenuItem>

        <Divider sx={{ my: 1, borderColor: "rgba(0, 114, 206, 0.2)" }} />

        <MenuItem
          onClick={handleSignOut}
          sx={{
            fontWeight: 500,
            color: primaryBlue[700],
            "&:hover": {
              bgcolor: "rgba(0, 114, 206, 0.1)",
            },
          }}
        >
          Sign Out
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserMenu;
